/**
 * Resolves email from Auth0 user object.
 * Auth0 may expose email in user.email or in a custom namespaced claim.
 */
export function getEmailFromAuth0User(auth0User) {
  if (!auth0User) return null
  return (
    auth0User.email ||
    auth0User['https://playlearning.io/email'] ||
    auth0User.user_email ||
    null
  )
}
